// src/store/authSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { googleLoginRequest, loginFailure, loginRequest, loginSuccess } from "./auth.slice.js";

// Worker saga for login
function* handleLogin(action) {
  try {
    const response = yield call(() =>
      axios.post("http://localhost:3000/auth/login", action.payload)
    );

    const { token, user } = response.data;

    // Save to localStorage
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));

    yield put(loginSuccess({ token, user }));
  } catch (error) {
    yield put(loginFailure(error.response?.data?.error || "Login failed"));
  }
}

// Worker saga for Google login
function* handleGoogleLogin(action) {
  try {
    const response = yield call(() =>
      axios.post("http://localhost:3000/auth/login", {
        google_id: action.payload.googleId,
        email: action.payload.email,
        role: action.payload.role || "admin", // or "user"
      })
    );

    const { token, user } = response.data;
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));

    yield put(loginSuccess({ token, user }));
  } catch (error) {
    yield put(loginFailure(error.response?.data?.error || "Google login failed"));
  }
}

export default function* authSaga() {
  yield takeLatest(loginRequest.type, handleLogin);
  yield takeLatest(googleLoginRequest.type, handleGoogleLogin);
}
